import React from 'react'
import SeatBooking from '../../components/SeatBooking'

export const SeatBookingPage = () => {
  return (
      <>
      <SeatBooking />
      </>)
}
